import { TOGGLE_PLAN_D, TOGGLE_ADD_FEEDS_D, TOGGLE_MANAGE_FEEDS_D, TOGGLE_CUSTOMIZATION_D, TOGGLE_THEMES_SECTION_D, TOGGLE_PUBLISH_D,TOGGLE_APPSMORE_D, TOGGLE_AUTOPILOT_D, TOGGLE_PHOTOBOOTH_UPGRADE } from "../keys";

const reset = { showPricingD: false, showAppsMoreD: false, showAddFeedD: false, showManageFeedD: false, showThemesD: false, showCustomizationD: false, showPublishD: false, showAutoPilotD: false, showPhotoBoothUpgrade: false }

const initialState = { ...reset, }

export default function reducer(state = initialState, action) {
    const { type, payload } = action;

    switch (type) {

        case TOGGLE_PLAN_D: {
            return {
                ...reset, showPricingD: payload
            }
        }

        case TOGGLE_APPSMORE_D: {
            return {
                ...reset, showAppsMoreD: payload
            }
        }

        case TOGGLE_ADD_FEEDS_D: {
            return {
                ...reset, showAddFeedD: payload,

            }
        }

        case TOGGLE_MANAGE_FEEDS_D: {
            return {
                ...reset, showManageFeedD: payload,

            }
        }

        case TOGGLE_THEMES_SECTION_D: {
            return {
                ...reset, showThemesD: payload,
            }
        }

        case TOGGLE_CUSTOMIZATION_D: {
            return {
                ...reset,
                showCustomizationD: payload
            }
        }
        case TOGGLE_PUBLISH_D: {
            return {
                ...reset,
                showPublishD: payload
            }
        }
        case TOGGLE_AUTOPILOT_D: {
            return {
                ...reset,
                showAutoPilotD: payload
            }
        }
        case TOGGLE_PHOTOBOOTH_UPGRADE: {
            return {
                ...reset,
                showPhotoBoothUpgrade: payload
            }
        }
        

        default:
            return { ...state }
    }
}